var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.18,
    height: 20.18,
    viewBox: "0 0 20.18 20.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-close",
    "data-name": "Icon material-close",
    d: "M27.68,9.532,25.648,7.5,17.59,15.558,9.532,7.5,7.5,9.532l8.058,8.058L7.5,25.648,9.532,27.68l8.058-8.058,8.058,8.058,2.032-2.032L19.623,17.59Z",
    transform: "translate(-7.5 -7.5)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.915bf628c88eb5dfabad2100a961bfb5.svg";
export { ForwardRef as ReactComponent };